import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Initial = () => {
  const navigate = useNavigate();

  const firstpage = () => {
    navigate("/input");
  };

  const desview = () => {
    navigate("/encryptionview", {
      state: {
        hexkey,
        hexuserInput,
        KeyValue,
        userInput,
      },
    });
  };

  const location = useLocation();
  const userInput = location.state.userInput;
  const KeyValue = location.state.KeyValue;
  const hexuserInput = location.state.hexuserInput;
  const hexkey = location.state.hexkey;
  let dupInputValue = userInput;
  let hexInputValue = "";
  let binaryInputValue = "";

  let dupKeyValue = KeyValue;
  let hexKeyValue = "";
  let binaryKeyValue = "";

  

  return (
    <>
     <div className="mx-auto border border-solid p-16 mt-10 bg-sky-200 align-middle justify-center -mb-32 max-w-fit rounded-3xl">
      <h3 className="head">What is done in this page?</h3>
      <p>This page highlights the encryption process. The plaintext and the key are used to produce the desired cipher text.
        <br></br><br></br>
        For detailed explaination about various steps involved in Twofish Encryption please press the <b>view</b> button
      </p>
    </div>
      <div className="input-container">
        <div className="flex flex-col items-center max-h-64">
         
          <div className="grid grid-cols-3 gap-4 justify-center items-center h-screen">
            <div>
              <p className="text-xl">Plaintext</p>

              <div class="group relative">
                <div class="hidden absolute left-4 ml-64 p-3 bg-gray-700 text-white w-90 rounded shadow group-hover:block whitespace-nowrap">
                  Hexadecimal form of {dupInputValue}
                </div>
                <div class="border-solid border-black border-2 p-1 m-1">
                  <p>{hexuserInput}</p>
                </div>
              </div>

              <div className=" pl-24 pb-5">
                <svg
                  width="240"
                  height="70"
                  viewBox="0 0 297 106"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <line x1="1" y1="98" x2="1" stroke="black" stroke-width="2" />
                  <path
                    d="M296.708 98.4725C297.098 98.082 297.098 97.4488 296.708 97.0583L290.344 90.6943C289.953 90.3038 289.32 90.3038 288.929 90.6943C288.539 91.0848 288.539 91.718 288.929 92.1085L294.586 97.7654L288.929 103.422C288.539 103.813 288.539 104.446 288.929 104.836C289.32 105.227 289.953 105.227 290.344 104.836L296.708 98.4725ZM2 98.7654H296V96.7654H2V98.7654Z"
                    fill="black"
                  />
                </svg>
              </div>

              <div className=" pl-24 pt-5">
                <svg
                  width="240"
                  height="70"
                  viewBox="0 0 297 106"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <line
                    x1="1"
                    y1="106"
                    x2="1"
                    y2="8"
                    stroke="black"
                    stroke-width="2"
                  />
                  <path
                    d="M296.708 8.47249C297.098 8.08196 297.098 7.4488 296.708 7.05827L290.344 0.694313C289.953 0.303789 289.32 0.303789 288.929 0.694313C288.539 1.08484 288.539 1.718 288.929 2.10853L294.586 7.76538L288.929 13.4222C288.539 13.8128 288.539 14.4459 288.929 14.8364C289.32 15.227 289.953 15.227 290.344 14.8364L296.708 8.47249ZM2 8.76538H296V6.76538H2V8.76538Z"
                    fill="black"
                  />
                </svg>
              </div>

              <div class="group relative">
                <div class="hidden absolute left-0 ml-64 p-3 bg-gray-700 text-white w-90 rounded shadow group-hover:block whitespace-nowrap">
                  Hexadecimal form of {dupKeyValue}
                </div>
                <div class="border-solid border-black border-2 p-1 m-1">
                  <p>{hexkey}</p>
                </div>
              </div>

              <p className="text-xl">Key</p>
            </div>
            <div className="grid grid-cols-2 justify-center items-center">
              <div className="bg-blue-700 p-4 rounded-lg shadow-lg text-white">
                <p className="text-lg font-semibold">Twofish Encryption</p>
                <button
                  onClick={desview}
                  className="bg-white text-blue-500 px-4 py-2 mt-2 rounded hover:bg-blue-200 hover:text-blue-700 transition duration-300"
                >
                  View
                </button>
              </div>
              <div>
                <svg
                  width="160"
                  height="20"
                  viewBox="0 0 129 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M128.002 8.98779L113.002 0.327539V17.648L128.002 8.98779ZM0.998047 10.4878H114.502V7.48779H0.998047V10.4878Z"
                    fill="black"
                  />
                </svg>
              </div>
            </div>
            <div>
              <p className="text-xl">Cipher Text</p>
              <div className="border-solid border-black border-2 p-1 m-1">
                <p>{}</p>
              </div>
            </div>
          </div>

          <div class="button-holder">
            <div class="prev-button" onClick={firstpage}>
              PREVIOUS
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Initial;